import { apiClient } from '@/lib/api-client';
import { ConfigurationModel } from '@/models/configurationModel';

export interface SupportActionPermissions {
  isSupport: boolean;
  isCompanyOne: boolean;
  deleteAllEnabled: boolean;
}

class ConfigurationService {
  async canAccessConfiguration(companyId: number): Promise<boolean> {
    const result = await apiClient.get<boolean>(
      `/api/Configuration/CanAccessConfiguration?companyId=${companyId}`
    );
    return result ?? false;
  }

  async getConfiguration(companyId: number): Promise<ConfigurationModel> {
    const result = await apiClient.get<ConfigurationModel>(
      `/api/Configuration/GetConfiguration?companyId=${companyId}`
    );
    return result ?? {
      AllowReload: false,
      PublishFolder: '',
      ReviewFolder: '',
      ValidatePdfs: false,
      ValidateChecksums: false,
    };
  }

  async saveConfiguration(
    companyId: number,
    configuration: ConfigurationModel
  ): Promise<string> {
    const result = await apiClient.post<string>('/api/Configuration/SaveConfiguration', {
      companyId,
      configuration,
    });
    return result ?? '';
  }
  async getSupportActionPermissions(companyId: number): Promise<SupportActionPermissions> {
    const result = await apiClient.get<SupportActionPermissions>(
      `/api/Configuration/CanAccessSupportActions?companyId=${companyId}`
    );
    return result ?? { isSupport: false, isCompanyOne: false, deleteAllEnabled: false };
  }

  async loadAllApplications(companyId: number): Promise<void> {
    await apiClient.post<void>(
      `/api/Configuration/LoadAllApplications?companyId=${companyId}`
    );
  }

  async updateAllApplications(companyId: number): Promise<void> {
    await apiClient.post<void>(
      `/api/Configuration/UpdateAllApplications?companyId=${companyId}`
    );
  }

  async deleteAllApplications(companyId: number): Promise<void> {
    await apiClient.post<void>(
      `/api/Configuration/DeleteAllApplications?companyId=${companyId}`
    );
  }

  async initializeStaticData(companyId: number): Promise<void> {
    await apiClient.post<void>(
      `/api/Configuration/InitializeStaticData?companyId=${companyId}`
    );
  }
}

export const configurationService = new ConfigurationService();
